import Loading from '@components/shared/Loading';
import { useCurrentReport, useCurrentReports } from '../../hooks/useReports';
import { Summary } from './Summary';
import { Alert } from '@mui/material';
import { useCurrentCampaign } from '../../hooks/useCampaign';

export const SummaryContainer = () => {
  const { report, loading: loadingReport } = useCurrentReport();
  const { reports: allReports, loading: loadingAllReports } =
    useCurrentReports();
  const { campaign, isFetching: loadingCampaign } = useCurrentCampaign();

  if (loadingReport || loadingAllReports || loadingCampaign) return <Loading />;

  if (!report || !allReports?.length || !campaign)
    return <Alert severity="error">Error loading campaign data.</Alert>;

  return (
    <Summary report={report} allReports={allReports} campaign={campaign} />
  );
};
